export const MERCADO_DETALLE_LAYOUTS = {
  EJECUTADA: {
    estadoIntervencion: 1,

    header: {
      titulo: "nombreProyecto",
      subtitulo: ["tipoMercado", "departamento", "provincia", "distrito"],
    },

    bloques: [
      {
        titulo: "Datos Generales",
        grid: 3,
        campos: [
          { key: "codigo", idInfra: 60 },
          { key: "tipoMercado", idInfra: 80 },
          { key: "administracion", idInfra: 79 },
        ],
      },

      {
        titulo: "Ubicación",
        grid: 3,
        campos: [
          { key: "departamento", idInfra: 67 },
          { key: "provincia", idInfra: 66 },
          { key: "distrito", idInfra: 65 },
          { key: "ubigeo", idInfra: 138 }, // 👈 nuevo
        ],
      },

      {
        titulo: "Inversión",
        grid: 3,
        campos: [
          { key: "cuiProyecto", idInfra: 70 },
          { key: "costoInversion", idInfra: 73 },
          { key: "beneficiarios", idInfra: 74 },
          { key: "puestos", idInfra: 75 },
        ],
      },

      {
        titulo: "Unidades",
        grid: 2,
        campos: [
          { key: "uf", idInfra: 92 },   // Unidad Formuladora
          { key: "uei", idInfra: 97 },  // Unidad Ejecutora
        ],
      },

      {
        titulo: "Ejecución",
        grid: 3,
        campos: [
          { key: "inicioEjecucion", idInfra: 123 },
          { key: "fechaRecepcion", idInfra: 128 },
          { key: "fechaCulminacion", idInfra: 127 },
          { key: "montoAcumuladoEjec", idInfra: 144 },
          { key: "avanceEjec", idInfra: 145 },
        ],
      },
    ],

    imagenes: {
      habilitado: true,
      placeholder: true, // luego endpoint
    },
  },
  EN_EJECUCION: {
    estadoIntervencion: 2,

    header: {
      titulo: "nombreProyecto",
      subtitulo: ["tipoMercado", "departamento", "provincia", "distrito"],
    },

    fichaPrincipal: {
      filas: [
        { label: "UBICACIÓN", key: "ubicacionTexto" },
        { label: "UBIGEO", key: "ubigeo" },
        { label: "TIPO", key: "tipoMercado" },
        { label: "CUI", key: "cuiProyecto" },
        { label: "ENTREGA DE OBRA", key: "fechaRecepcion" },
        { label: "N° PUESTOS", key: "puestos" },
        { label: "COSTO INVERSIÓN", key: "costoInversion" },
        { label: "BENEFICIARIOS", key: "beneficiarios" },
        { label: "UNIDAD FORMULADORA", key: "uf" },
        { label: "UNIDAD EJECUTORA", key: "uei" },
      ],

      estadoCoord: {
        estadoKey: "estadoGeneral",
        coordKey: "coordsTexto",
      },

      caracteristicasKey: "caracteristicas",
    },
    detallesClick: [
      {
        key: "CONVENIO",
        label: "CONVENIO",
        secciones: [
          {
            titulo: "DATOS DEL CONVENIO",
            filas: [
              { label: "TIPO DE CONVENIO", key: "tipoConvenio" },
              { label: "ESTADO", key: "estadoConvenio" },
              { label: "ENTIDAD", key: "entidadConvenio" },
              { label: "OBJETO", key: "objetoConvenio" },
              { label: "INICIO DE VIGENCIA", key: "inicioVigencia" },
              { label: "PLAZO", key: "plazoConvenio" },
              { label: "FIN DE VIGENCIA", key: "finVigencia" },
            ],
          },
        ],
      },
      {
        key: "DESC_PROY",
        label: "DESCRIPCION DEL PROYECTO",
        secciones: [
          {
            titulo: "DESCRIPCION DEL PROYECTO",
            filas: [
              { label: "MERCADO DE CONTINGENCIA (Entrega parcial)", key: "mercadoContingencia" },
              { label: "MERCADO PRINCIPAL", key: "nombreProyecto" },
              { label: "ÁREA DEL TERRENO", key: "areaPredio" },
              { label: "ÁREA CONSTRUIDA", key: "areaConstruida" },
              { label: "NIVELES", key: "pisos" },
              { label: "OTROS", key: "otrosDesc" },
            ],
          },
        ],
      },
      {
        key: "EJEC_FISICA",
        label: "EJECUCION FÍSICA",
        secciones: [
          {
            titulo: "EJECUCIÓN FÍSICA",
            filas: [
              { label: "CONTRATISTA", key: "contratistaEjec" },
              { label: "MONTO CONTRACTUAL OBRA", key: "costoEjecucion" },
              { label: "SUPERVISOR", key: "contratistaSupervisionEjec" },
              { label: "MONTO CONTRACTUAL SUPERV", key: "costoSupervisionEjec" },
              { label: "FECHA DE INICIO DE EJECUCIÓN", key: "inicioEjecucion" },
              { label: "FECHA DE FIN DE OBRA", key: "fechaCulminacion" },
              { label: "MONTO ACUMULADO VALORIZADO (S/.)", key: "montoAcumuladoEjec" },
              { label: "AVANCE", key: "avanceEjec" },
              { label: "EJEC.PROG / EJEC", key: "ejecProgTexto" },
              { label: "EJECUCION ACTUAL", key: "desarrolloEjec" },
              { label: "OTROS", key: "otrosEjec" },
            ],
          },
        ],
      },
    ],

    imagenes: {
      habilitado: true,
      placeholder: true,
    },
  },
  EXP_TEC: {
    estadoIntervencion: 4,

    header: {
      titulo: "nombreProyecto",
      subtitulo: ["tipoMercado", "departamento", "provincia", "distrito"],
    },

    fichaPrincipal: {
      filas: [
        { label: "UBICACIÓN", key: "ubicacionTexto" },
        { label: "UBIGEO", key: "ubigeo" },
        { label: "TIPO", key: "tipoMercado" },
        { label: "CUI", key: "cuiProyecto" },
        { label: "N° PUESTOS", key: "puestos" },
        { label: "COSTO INVERSIÓN", key: "costoInversion" },
        { label: "BENEFICIARIOS", key: "beneficiarios" },
        { label: "UNIDAD FORMULADORA", key: "uf" },
        { label: "UNIDAD EJECUTORA", key: "uei" },
      ],

      estadoCoord: {
        estadoKey: "estadoElab",
        coordKey: "coordsTexto",
      },

      caracteristicasKey: "caracteristicas",
    },

    detallesClick: [
      {
        key: "CONVENIO",
        label: "CONVENIO",
        secciones: [
          {
            titulo: "DATOS DEL CONVENIO",
            filas: [
              { label: "TIPO DE CONVENIO", key: "tipoConvenio" },
              { label: "ESTADO", key: "estadoConvenio" },
              { label: "ENTIDAD", key: "entidadConvenio" },
              { label: "OBJETO", key: "objetoConvenio" },
              { label: "INICIO DE VIGENCIA", key: "inicioVigencia" },
              { label: "PLAZO", key: "plazoConvenio" },
              { label: "FIN DE VIGENCIA", key: "finVigencia" },
            ],
          },
        ],
      },
      {
        key: "ELABORACION",
        label: "ELABORACIÓN ET", // El componente lo renombrará a "DETALLES:" para ID 3
        secciones: [
          {
            titulo: "ELABORACIÓN DE EXPEDIENTE TÉCNICO",
            filas: [
              { label: "PROYECTISTA", key: "contratistaElab" },
              { label: "Nº de Contrato", key: "contratoElaboracion" },
              { label: "SUPERVISOR", key: "contratistaSupervisionElab" },
              { label: "Nº de Contrato", key: "contratoSupervisionElab" },
              { label: "FECHA DE INICIO DE EE.TT.", key: "inicioElaboracion" },
              { label: "ADMINISTRADOR DE CONTRATO", key: "adminContrato" },
              { label: "AVANCE DE LA ELABORACIÓN DEL EE. TT. (%)", key: "avanceElab" },
              { label: "ESTADO ACTUAL", key: "estadoElab" },
              { label: "HITOS", key: "hito" },
              { label: "OTROS", key: "otrosET" },
            ],
          },
        ],
      },
    ],

    imagenes: {
      habilitado: true,
      placeholder: true,
    },
  },
  PREINVERSION: {
    estadoIntervencion: 6,

    header: {
      titulo: "nombreProyecto",
      subtitulo: ["tipoMercado", "departamento", "provincia", "distrito"],
    },

    fichaPrincipal: {
      filas: [
        { label: "ETAPA", key: "etapaLabel", highlight: true }, 
        { label: "ELABORADO POR", key: "ejecutadoPorLabel", highlight: true },
        { label: "UBICACIÓN", key: "ubicacionTexto" },
        { label: "UBIGEO", key: "ubigeo" },
        { label: "TIPO", key: "tipoMercado" },
        { label: "CUI", key: "cuiProyecto" },
        { label: "N° PUESTOS", key: "puestos" },
        { label: "COSTO INVERSIÓN", key: "costoInversion" },
        { label: "BENEFICIARIOS", key: "beneficiarios" },
        { label: "UNIDAD FORMULADORA", key: "uf" },
        { label: "UNIDAD EJECUTORA DE INV.", key: "uei" },
        { label: "MODALIDAD", key: "modalidadTexto" },
        { label: "FECHA DE VIABILIDAD", key: "fechaViabilidad", highlight: true },
      ],

      caracteristicasKey: "caracteristicas",
    },

    detallesClick: [
      {
        key: "CONVENIO",
        label: "CONVENIO",
        secciones: [
          {
            titulo: "DATOS DEL CONVENIO",
            filas: [
              { label: "TIPO DE CONVENIO", key: "tipoConvenio" },
              { label: "ESTADO", key: "estadoConvenio" },
              { label: "ENTIDAD", key: "entidadConvenio" },
              { label: "OBJETO", key: "objetoConvenio" },
              { label: "INICIO DE VIGENCIA", key: "inicioVigencia" },
              { label: "PLAZO", key: "plazoConvenio" },
              { label: "FIN DE VIGENCIA", key: "finVigencia" },
            ],
          },
        ],
      },
    ],


    imagenes: {
      habilitado: true,
      placeholder: true,
    },
  },
  DEFAULT: {
    estadoIntervencion: null,

    header: {
      titulo: "nombreProyecto",
      subtitulo: ["tipoMercado", "departamento", "provincia", "distrito"],
    },

    // Reutilizamos un bloque tipo “ejecutada” pero más general
    bloques: [
      {
        titulo: "Datos Generales",
        grid: 3,
        campos: [
          { key: "codigo", idInfra: 60 },
          { key: "tipoMercado", idInfra: 80 },
          { key: "administracion", idInfra: 79 },
        ],
      },
      {
        titulo: "Ubicación",
        grid: 3,
        campos: [
          { key: "departamento", idInfra: 67 },
          { key: "provincia", idInfra: 66 },
          { key: "distrito", idInfra: 65 },
          { key: "ubigeo", idInfra: 138 },
        ],
      },
      {
        titulo: "Inversión",
        grid: 3,
        campos: [
          { key: "cuiProyecto", idInfra: 70 },
          { key: "costoInversion", idInfra: 73 },
          { key: "beneficiarios", idInfra: 74 },
          { key: "puestos", idInfra: 75 },
        ],
      },
    ],
  }
};
